"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _vars = require("@devsta/ui-kit/dist/common/styles/vars");

var _default = function _default(hoursLeft, status) {
  if (status === 'ON_HOLD') {
    return {
      color: _vars.COLOURS.grey.mischka.russian,
      status: {
        neutral: true
      }
    };
  }

  if (hoursLeft > 4) {
    return {
      color: _vars.COLOURS.cyan.jungleGreen.monkey,
      status: {
        success: true
      }
    };
  }

  if (hoursLeft > 2) {
    return {
      color: _vars.COLOURS.yellow.goldenTainoi,
      status: {
        warning: true
      }
    };
  }

  return {
    color: _vars.COLOURS.red.redApple,
    status: {
      danger: true
    }
  };
};

exports.default = _default;